import React from "react";

const ContactFormSection = () => {
  return (
    <div className="contact-form-section section-padding pt-0 fix">
      <div className="contact-form-wrapper style2">
        <div className="container">
          <div className="row gx-60 gy-5">

            {/* Image Section */}
            <div className="col-xl-6">
              <div className="contact-form-thumb">
                <img  className="con_image"
                  src="/assets/img/contact/Contact1.jpg"
                  alt="thumb"
                />
              </div>
            </div>

            {/* Form Section */}
            <div className="col-xl-6">
              <div className="contact-form style2">
                <h2>Get in Touch</h2>
                <form className="row" action="#">

                  {/* Full Name */}
                  <div className="col-md-6">
                    <input type="text" placeholder="Full Name" />
                  </div>

                  {/* Email */}
                  <div className="col-md-6">
                    <input type="email" placeholder="Email Address" />
                  </div>

                  {/* Phone */}
                  <div className="col-md-6">
                    <input type="number" placeholder="Phone Number" />
                  </div>

                  {/* Subject */}
                  <div className="col-md-6">
                    <select name="subject" className="single-select" aria-label="Subject">
                      <option value="subject" selected>Subject</option>
                      <option value="complain">Complain</option>
                      {/* <option value="greetings">Greetings</option>
                      <option value="date">Expire Date</option>
                      <option value="price">About Price</option> */}
                      <option value="order">About Order</option>
                    </select>
                  </div>

                  {/* Message */}
                  <div className="col-12">
                    <textarea
                      id="message"
                      className="form-control"
                      placeholder="Write your message here..."
                      rows="5"
                    ></textarea>
                  </div>

                  {/* Checkbox */}
                  <div className="col-12 form-group">
                    <input id="reviewcheck" name="reviewcheck" type="checkbox" />
                    <label htmlFor="reviewcheck">
                      Collaboratively formulate principle capital. Progressively
                      evolve user
                      <span className="checkmark"></span>
                    </label>
                  </div>

                  {/* Submit Button */}
                  <div className="col-12 form-group mb-0">
                    <button className="theme-btn w-100" type="submit">
                      SUBMIT NOW{" "}
                      <i className="fa-sharp fa-regular fa-arrow-right-long bg-transparent text-white"></i>
                    </button>
                  </div>

                </form>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactFormSection;
